import React from 'react';

/**
 * Deal Grade Component
 * Converts CI Score (0-1000) to letter grade (A-D) with color coding
 */
export const DealGrade = ({ score, showLabel = true, size = 'md' }) => {
  // Determine grade and styling based on CI Score
  const getGrade = (score) => {
    if (score >= 800) return { grade: 'A', label: 'Excellent', color: 'green', bgColor: 'bg-green-500/20', borderColor: 'border-green-500/40', textColor: 'text-green-400' };
    if (score >= 600) return { grade: 'B', label: 'Good', color: 'blue', bgColor: 'bg-blue-500/20', borderColor: 'border-blue-500/40', textColor: 'text-blue-400' };
    if (score >= 400) return { grade: 'C', label: 'Average', color: 'yellow', bgColor: 'bg-yellow-500/20', borderColor: 'border-yellow-500/40', textColor: 'text-yellow-400' };
    return { grade: 'D', label: 'Poor', color: 'red', bgColor: 'bg-red-500/20', borderColor: 'border-red-500/40', textColor: 'text-red-400' };
  };

  const gradeInfo = getGrade(score);

  // Size variants
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2',
  };

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-lg border ${gradeInfo.bgColor} ${gradeInfo.borderColor} ${sizeClasses[size]}`}
      data-testid="deal-grade"
    >
      <span className={`font-bold ${gradeInfo.textColor}`}>
        {gradeInfo.grade}
      </span>
      {showLabel && (
        <span className={`${gradeInfo.textColor} opacity-80`}>
          {gradeInfo.label}
        </span>
      )}
    </div>
  );
};

/**
 * CI Score with Grade Component
 * Shows CI Score number with grade badge
 */
export const CIScoreWithGrade = ({ score, showExplanation = false }) => {
  return (
    <div className="inline-flex items-center gap-2" data-testid="ci-score-with-grade">
      <span className="text-2xl font-bold text-white">{score}</span>
      <DealGrade score={score} showLabel={true} size="md" />
      {showExplanation && (
        <div className="ml-1">
          {/* Will import CIScoreExplanation component here */}
        </div>
      )}
    </div>
  );
};

export default DealGrade;
